(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3234,687],{

/***/ 48491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Breadcrumbs": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Oo; },
/* harmony export */   "BrowserClient": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.RE; },
/* harmony export */   "BrowserProfilingIntegration": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__._p; },
/* harmony export */   "BrowserTracing": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.gE; },
/* harmony export */   "Dedupe": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Iq; },
/* harmony export */   "ErrorBoundary": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SV; },
/* harmony export */   "Feedback": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.x2; },
/* harmony export */   "FunctionToString": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.cq; },
/* harmony export */   "GlobalHandlers": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.dJ; },
/* harmony export */   "HttpContext": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qT; },
/* harmony export */   "Hub": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Xb; },
/* harmony export */   "InboundFilters": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.QD; },
/* harmony export */   "Integrations": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.jK; },
/* harmony export */   "LinkedErrors": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.iP; },
/* harmony export */   "ModuleMetadata": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__._e; },
/* harmony export */   "Profiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Q1; },
/* harmony export */   "Replay": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.UH; },
/* harmony export */   "SDK_VERSION": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Jn; },
/* harmony export */   "Scope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sX; },
/* harmony export */   "TryCatch": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.pT; },
/* harmony export */   "WINDOW": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.m9; },
/* harmony export */   "addBreadcrumb": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.n_; },
/* harmony export */   "addEventProcessor": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Qy; },
/* harmony export */   "addGlobalEventProcessor": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.cc; },
/* harmony export */   "addIntegration": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.M5; },
/* harmony export */   "addTracingExtensions": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Ts; },
/* harmony export */   "captureEvent": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.eN; },
/* harmony export */   "captureException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Tb; },
/* harmony export */   "captureMessage": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "captureUnderscoreErrorException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ud; },
/* harmony export */   "captureUserFeedback": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Jd; },
/* harmony export */   "chromeStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$3; },
/* harmony export */   "close": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.xv; },
/* harmony export */   "configureScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.e; },
/* harmony export */   "continueTrace": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.yn; },
/* harmony export */   "createReduxEnhancer": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.wS; },
/* harmony export */   "createTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qv; },
/* harmony export */   "createUserFeedbackEnvelope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rQ; },
/* harmony export */   "defaultIntegrations": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SS; },
/* harmony export */   "defaultRequestInstrumentationOptions": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.k3; },
/* harmony export */   "defaultStackLineParsers": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.d8; },
/* harmony export */   "defaultStackParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Dt; },
/* harmony export */   "eventFromException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.dr; },
/* harmony export */   "eventFromMessage": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.aB; },
/* harmony export */   "exceptionFromError": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.GJ; },
/* harmony export */   "extractTraceparentData": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qG; },
/* harmony export */   "flush": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.yl; },
/* harmony export */   "forceLoad": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Eg; },
/* harmony export */   "geckoStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$Q; },
/* harmony export */   "getActiveSpan": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.HN; },
/* harmony export */   "getActiveTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.x1; },
/* harmony export */   "getClient": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.s3; },
/* harmony export */   "getCurrentHub": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Gd; },
/* harmony export */   "getCurrentScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.nZ; },
/* harmony export */   "getHubFromCarrier": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vi; },
/* harmony export */   "init": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.S1; },
/* harmony export */   "instrumentOutgoingRequests": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.L7; },
/* harmony export */   "lastEventId": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.eW; },
/* harmony export */   "makeBrowserOfflineTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.O1; },
/* harmony export */   "makeFetchTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.fD; },
/* harmony export */   "makeMain": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.pj; },
/* harmony export */   "makeMultiplexedTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Wq; },
/* harmony export */   "makeXHRTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.KC; },
/* harmony export */   "metrics": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qI; },
/* harmony export */   "nextRouterInstrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.q$; },
/* harmony export */   "onLoad": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.lA; },
/* harmony export */   "onProfilingStartRouteTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Uv; },
/* harmony export */   "opera10StackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.NP; },
/* harmony export */   "opera11StackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.HH; },
/* harmony export */   "reactRouterV3Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.XQ; },
/* harmony export */   "reactRouterV4Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qr; },
/* harmony export */   "reactRouterV5Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qp; },
/* harmony export */   "reactRouterV6Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.KO; },
/* harmony export */   "setContext": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.v; },
/* harmony export */   "setExtra": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sU; },
/* harmony export */   "setExtras": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rJ; },
/* harmony export */   "setMeasurement": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.oi; },
/* harmony export */   "setTag": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.YA; },
/* harmony export */   "setTags": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.mG; },
/* harmony export */   "setUser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.av; },
/* harmony export */   "showReportDialog": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.jp; },
/* harmony export */   "spanStatusfromHttpCode": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Zd; },
/* harmony export */   "startInactiveSpan": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Qb; },
/* harmony export */   "startSpan": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.GK; },
/* harmony export */   "startSpanManual": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.V0; },
/* harmony export */   "startTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Yr; },
/* harmony export */   "trace": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.g4; },
/* harmony export */   "useProfiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ED; },
/* harmony export */   "winjsStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.R2; },
/* harmony export */   "withErrorBoundary": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Pf; },
/* harmony export */   "withProfiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.zH; },
/* harmony export */   "withScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$e; },
/* harmony export */   "withSentryConfig": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.wO; },
/* harmony export */   "withSentryGetServerSideProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sT; },
/* harmony export */   "withSentryGetStaticProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SF; },
/* harmony export */   "withSentryReactRouterV6Routing": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.H0; },
/* harmony export */   "withSentryRouting": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.gy; },
/* harmony export */   "withSentryServerSideAppGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Im; },
/* harmony export */   "withSentryServerSideDocumentGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.W9; },
/* harmony export */   "withSentryServerSideErrorGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vw; },
/* harmony export */   "withSentryServerSideGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.EC; },
/* harmony export */   "withServerActionInstrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.NF; },
/* harmony export */   "wrap": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.re; },
/* harmony export */   "wrapApiHandlerWithSentryVercelCrons": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.LH; },
/* harmony export */   "wrapAppGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$l; },
/* harmony export */   "wrapCreateBrowserRouter": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vG; },
/* harmony export */   "wrapDocumentGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.B4; },
/* harmony export */   "wrapErrorGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rO; },
/* harmony export */   "wrapGenerationFunctionWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.J$; },
/* harmony export */   "wrapGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.O5; },
/* harmony export */   "wrapGetServerSidePropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rC; },
/* harmony export */   "wrapGetStaticPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ug; },
/* harmony export */   "wrapMiddlewareWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.l7; },
/* harmony export */   "wrapPageComponentWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ri; },
/* harmony export */   "wrapRouteHandlerWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.zv; },
/* harmony export */   "wrapServerComponentWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.D_; },
/* harmony export */   "wrapUseRoutes": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.M1; }
/* harmony export */ });
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37950);


/***/ }),

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 22044:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/competitor-template-page",
      function () {
        return __webpack_require__(68439);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgV = function SvgV(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 20,
        viewBox: "0 0 26 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M9 14 3 8l-3 3 6 6 3 3 3-3L26 3l-3-3z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgV);


/***/ }),

/***/ 77385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignupWithTextComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.scss.js


var StyledSignupWithTextComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewvr9040"
})("width:100%;position:relative;.signup-form-title{text-align:center;margin-bottom:24px;h1{font-weight:500;}}&.with-subtitle{.signup-form-title{margin-bottom:8px;}}&.text-under-buttons{.signup-form-subtitle{margin-bottom:0;margin-top:24px;}}.signup-form-subtitle{text-align:center;h2{font-weight:300;}margin-bottom:24px;}.error-tooltip-text{color:red;font-weight:300;}.tooltip{transform:translate(10%,-120%);}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.tooltip{transform:translate(5%,-120%);}}");

;// CONCATENATED MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var SignupWithTextComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupWithTextComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupWithTextComponent);
    function SignupWithTextComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SignupWithTextComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(SignupWithTextComponent, [
        {
            key: "renderTexts",
            value: function renderTexts() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "signup-texts",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: title
                            })
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-subtitle",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: subtitle
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "renderForm",
            value: function renderForm() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread({}, this.props));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, subtitle = _props.subtitle, textUnderButtons = _props.textUnderButtons;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupWithTextComponent, {
                    className: classnames_default()("signup-form-wrapper", {
                        "with-subtitle": subtitle,
                        "text-under-buttons": textUnderButtons
                    }),
                    children: [
                        textUnderButtons ? this.renderForm() : this.renderTexts(),
                        textUnderButtons ? this.renderTexts() : this.renderForm()
                    ]
                });
            }
        }
    ]);
    return SignupWithTextComponent;
}(react.PureComponent);

SignupWithTextComponent.defaultProps = {
    textUnderButtons: false
};


/***/ }),

/***/ 73418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hamburger_menu_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.scss.js



var StyledHamburgerMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ajo1f0"
})("width:28px;transform:rotate(0deg);cursor:pointer;z-index:", z_index/* SIDE_NAV */.gR + 1, ";margin-left:24px;margin-right:8px;height:36px;display:flex;.hamburger-menu-line{display:block;position:absolute;height:3px;width:100%;background-color:", colors/* default.black */.Z.black, ";border-radius:4px;opacity:1;left:0;transform:rotate(0deg);transition:all 0.2s ease-in-out;&:nth-child(1){top:8px;}&:nth-child(2),&:nth-child(3){top:17px;}&:nth-child(4){top:26px;}}&.open{.hamburger-menu-line{background-color:", colors/* default.black */.Z.black, ";&:nth-child(1){top:18px;width:0%;left:50%;}&:nth-child(2){transform:rotate(45deg);}&:nth-child(3){transform:rotate(-45deg);}&:nth-child(4){top:18px;width:0;left:50%;}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js










var HamburgerMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HamburgerMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HamburgerMenuComponent);
    function HamburgerMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HamburgerMenuComponent);
        var _this;
        _this = _super.call(this, props);
        _this.toggleOpenState = _this.toggleOpenState.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.toggleOpenState);
        return _this;
    }
    (0,_create_class/* default */.Z)(HamburgerMenuComponent, [
        {
            key: "toggleOpenState",
            value: function toggleOpenState() {
                var isOpen = this.props.isOpen;
                this.props.changeStateCallback(!isOpen);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, theme = _props.theme, isInScrollMode = _props.isInScrollMode, isOpen = _props.isOpen, translate = _props.translate;
                var scrollModeClass = isInScrollMode ? "scroll-mode" : "";
                var openMode = isOpen ? "open" : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHamburgerMenuComponent, {
                    className: "hamburger-menu ".concat(theme, " ").concat(scrollModeClass, " ").concat(openMode),
                    tabIndex: 0,
                    onClick: this.toggleOpenState,
                    onKeyDown: this.onKeyDown,
                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                    "aria-label": isOpen ? translate("header.closeMenu") : translate("header.openMenu"),
                    "aria-haspopup": "menu",
                    "aria-expanded": isOpen,
                    role: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        })
                    ]
                });
            }
        }
    ]);
    return HamburgerMenuComponent;
}(react.PureComponent);
HamburgerMenuComponent.defaultProps = {
    changeStateCallback: function() {},
    isInScrollMode: false,
    theme: "",
    isOpen: false
};
/* harmony default export */ var hamburger_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(HamburgerMenuComponent));


/***/ }),

/***/ 93030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompetitorsComparisonTableComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.scss.js


var StyledCompetitorsComparisonTableComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e98igvu0"
})("text-align:center;margin-top:50px;.competitors-comparison-title{font-size:2.2vw;margin-bottom:20px;font-weight:500;}.competitors-comparison-subtitle{font-size:1.4vw;font-weight:300;line-height:1.3;margin-bottom:20px;}.table-wrapper{padding:50px 100px;.table-header{padding-bottom:20px !important;.vs-cell{font-size:1.463rem;font-weight:400;}}.table-row{display:flex;padding:0px 30px;.table-cell{flex:1 1;height:80px;display:flex;align-items:center;justify-content:center;}.first-cell{justify-content:left;}.monday-logo-wrapper{width:100%;img{width:80%;max-width:200px;}}.competitor-logo-wrapper{width:100%;img{width:80%;max-width:200px;}}}}.mobile-table-wrapper{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.competitors-comparison-titles-wrapper{padding:0px 20px;width:80%;margin:0px auto;.competitors-comparison-title{font-size:1.575rem;text-align:left;line-height:1.3;}.competitors-comparison-subtitle{font-size:0.875rem;text-align:left;line-height:1.5;}}.table-wrapper{display:none;}.mobile-table-wrapper{display:block;margin:50px 0px;.table-header{display:flex;padding:10px 0px;.monday-logo-wrapper,.competitor-logo-wrapper{width:100%;img{width:80%;}}}}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/comparison-feature/comparison-feature-component.scss.js


var StyledComparisonFeatureComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egkw7zd0"
})(".table-row{&.even{background:#ecf4f8;border-radius:40px;}&.big-texts{.table-cell:not(.first-cell){font-size:1.375rem;}}}.mobile-table-row{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.table-row{display:none;}.mobile-table-row{display:block;.feature-title{display:flex;height:40px;align-items:center;justify-content:center;}.feature-cells{display:flex;height:50px;align-items:center;background:#ecf4f8;border-radius:30px;margin:0px 5vw;.table-cell{flex:1 0;}}}}");

// EXTERNAL MODULE: ./static/svg/competitors-template/v.svg
var v = __webpack_require__(37531);
;// CONCATENATED MODULE: ./static/svg/competitors-template/x.svg
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgX = function SvgX(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        viewBox: "0 0 25 25"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#FF3D57",
        strokeLinecap: "square",
        strokeWidth: 4.5
    }, /*#__PURE__*/ react.createElement("path", {
        d: "m4 4 17 17M21 4 4 21"
    }))));
};
/* harmony default export */ var x = (SvgX);

;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/comparison-feature/comparison-feature-component.js









var ComparisonFeatureComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ComparisonFeatureComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ComparisonFeatureComponent);
    function ComparisonFeatureComponent() {
        (0,_class_call_check/* default */.Z)(this, ComparisonFeatureComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ComparisonFeatureComponent, [
        {
            key: "renderFeatureValueContnet",
            value: function renderFeatureValueContnet(value) {
                if (value === "true") return /*#__PURE__*/ (0,jsx_runtime.jsx)(v/* default */.Z, {
                    fill: "#00D647"
                });
                if (value === "false") return /*#__PURE__*/ (0,jsx_runtime.jsx)(x, {});
                return value;
            }
        },
        {
            key: "renderFeatureValue",
            value: function renderFeatureValue(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "feature-value",
                    children: this.renderFeatureValueContnet(value)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, monday = _props.monday, competitor = _props.competitor, index = _props.index, bigTexts = _props.bigTexts;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledComparisonFeatureComponent, {
                    className: "table-row-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "table-row table-feature ".concat(index % 2 == 0 ? "even" : "odd", " ").concat(bigTexts ? "big-texts" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell first-cell",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(monday)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(competitor)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mobile-table-row ".concat(bigTexts ? "big-texts" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "feature-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "feature-cells",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: this.renderFeatureValue(monday)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: this.renderFeatureValue(competitor)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ComparisonFeatureComponent;
}(react.PureComponent);

ComparisonFeatureComponent.defaultProps = {
    title: null,
    monday: null,
    competitor: null
};

;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var CompetitorsComparisonTableComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CompetitorsComparisonTableComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CompetitorsComparisonTableComponent);
    function CompetitorsComparisonTableComponent() {
        (0,_class_call_check/* default */.Z)(this, CompetitorsComparisonTableComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CompetitorsComparisonTableComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, features = _props.features, mondayLogo = _props.mondayLogo, competitorLogo = _props.competitorLogo;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCompetitorsComparisonTableComponent, {
                    className: "competitors-comparison-table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "competitors-comparison-titles-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "competitors-comparison-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "competitors-comparison-subtitle",
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "table-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "table-row table-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "monday-logo-wrapper",
                                                style: {
                                                    height: "".concat(mondayLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "monday-logo",
                                                    src: "/static/img/monday-logos/monday_logo_short.png"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell vs-cell",
                                            children: "vs."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: competitorLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "competitor-logo-wrapper",
                                                style: {
                                                    height: "".concat(competitorLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "competitor-logo",
                                                    src: competitorLogo.src
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell"
                                        })
                                    ]
                                }),
                                features.map(function(feature, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                        index: i
                                    }), i);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mobile-table-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "table-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "monday-logo-wrapper",
                                                style: {
                                                    height: "".concat(mondayLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "monday-logo",
                                                    src: "/static/img/monday-logos/monday_logo_short.png"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: competitorLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "competitor-logo-wrapper",
                                                style: {
                                                    height: "".concat(competitorLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "competitor-logo",
                                                    src: competitorLogo.src
                                                })
                                            })
                                        })
                                    ]
                                }),
                                features.map(function(feature, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                        index: i
                                    }), i);
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return CompetitorsComparisonTableComponent;
}(react.PureComponent);

CompetitorsComparisonTableComponent.defaultProps = {
    features: [],
    mondayLogo: {}
};


/***/ }),

/***/ 58072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompetitorTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js + 1 modules
var base_footer_component = __webpack_require__(44574);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 68 modules
var base_template = __webpack_require__(77445);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/header-with-two-columns-and-asset/header-with-two-columns-and-asset-component.scss.js


var componentStyles = new String(".header-with-two-columns-and-asset-component.jsx-cf7d2ee755054be1{min-height:-webkit-calc(100vh - 65px);min-height:-moz-calc(100vh - 65px);min-height:calc(100vh - 65px);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;.top-line.jsx-cf7d2ee755054be1{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-flex:1;-webkit-flex:1 0 auto;-moz-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;.content-column.jsx-cf7d2ee755054be1{-webkit-box-flex:0;-webkit-flex:0 0 50%;-moz-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.content-inner.jsx-cf7d2ee755054be1{width:80%;.content-title.jsx-cf7d2ee755054be1{font-size:3.2vw;margin-bottom:20px;font-weight:500}.content-subtitle.jsx-cf7d2ee755054be1{font-size:1.3vw;font-weight:400;line-height:1.3}.content-signup-form.jsx-cf7d2ee755054be1{.signup-form-wrapper{display:inline-block;text-align:left;.signup-form{.signup-input{padding:16px 35px}}}}.content-bullets.jsx-cf7d2ee755054be1{margin-top:40px;font-size:1.1vw;.bullet.jsx-cf7d2ee755054be1{margin-bottom:10px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:top;-webkit-align-items:top;-moz-box-align:top;-ms-flex-align:top;align-items:top;svg{margin-right:10px;width:16px;position:relative;top:0px}}}}}.asset-column.jsx-cf7d2ee755054be1{-webkit-box-flex:0;-webkit-flex:0 0 50%;-moz-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;position:relative;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;.asset-inner.jsx-cf7d2ee755054be1{width:80%;position:relative;.main-image{width:100%}}.hot-dog.jsx-cf7d2ee755054be1{position:absolute;width:100vw;height:40vw;background:orange;-webkit-border-radius:40vw;-moz-border-radius:40vw;border-radius:40vw;left:-10vh;bottom:55vh;-webkit-transform:rotate(-50deg);-moz-transform:rotate(-50deg);-ms-transform:rotate(-50deg);-o-transform:rotate(-50deg);transform:rotate(-50deg)}&.with-shadow.jsx-cf7d2ee755054be1{.asset-inner.jsx-cf7d2ee755054be1{-webkit-box-shadow:0px 2px 20px 1px rgba(177,177,177,.4);-moz-box-shadow:0px 2px 20px 1px rgba(177,177,177,.4);box-shadow:0px 2px 20px 1px rgba(177,177,177,.4)}}}.down-arrow-wrapper.jsx-cf7d2ee755054be1{position:absolute;bottom:20px;left:50%;-webkit-transform:translatex(-50%);-moz-transform:translatex(-50%);-ms-transform:translatex(-50%);-o-transform:translatex(-50%);transform:translatex(-50%);opacity:.5;svg{width:40px;height:40px}}}@media(max-width:".concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){min-height:auto;padding:30px 20px;text-align:center;&.white-on-mobile.jsx-cf7d2ee755054be1{.content-column.jsx-cf7d2ee755054be1{.content-inner.jsx-cf7d2ee755054be1{color:white;.bullet.jsx-cf7d2ee755054be1{svg{fill:white}}}}}.top-line.jsx-cf7d2ee755054be1{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-webkit-flex-direction:column!important;-moz-box-orient:vertical!important;-moz-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important;.content-column.jsx-cf7d2ee755054be1{position:relative;z-index:1;.content-inner.jsx-cf7d2ee755054be1{.content-title.jsx-cf7d2ee755054be1{font-size:1.575rem;margin-bottom:1.5vh;line-height:1.3}.content-subtitle.jsx-cf7d2ee755054be1{line-height:1.5;font-size:.875rem}.content-bullets.jsx-cf7d2ee755054be1{display:none}}}.asset-column.jsx-cf7d2ee755054be1{margin-top:20px;.hot-dog.jsx-cf7d2ee755054be1{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg);-webkit-border-radius:60vw;-moz-border-radius:60vw;border-radius:60vw;left:-10vh;bottom:10vh;right:-10vh;width:auto;height:200vh}}.down-arrow-wrapper.jsx-cf7d2ee755054be1{display:none}}}}"));
componentStyles.__hash = "cf7d2ee755054be1";

// EXTERNAL MODULE: ./static/svg/competitors-template/v.svg
var v = __webpack_require__(37531);
// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
;// CONCATENATED MODULE: ./components/segments/header-with-two-columns-and-asset/header-with-two-columns-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var DEFAULT_HOTDOG_COLOR = "brand-purple";
var HeaderWithTwoColumnsAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderWithTwoColumnsAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeaderWithTwoColumnsAndAssetComponent);
    function HeaderWithTwoColumnsAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, HeaderWithTwoColumnsAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HeaderWithTwoColumnsAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, signupForm = _props.signupForm, hotDog = _props.hotDog, title = _props.title, subtitle = _props.subtitle, asset = _props.asset, textColor = _props.textColor, imageWidth = _props.imageWidth, bullets = _props.bullets;
                var shadow = asset.shadow, image = asset.image;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(componentStyles.__hash) + " " + "header-with-two-columns-and-asset-component ".concat([
                        "brand-yellow",
                        "brand-light-blue"
                    ].indexOf(hotDog.color) > -1 ? "" : "white-on-mobile"),
                    children: [
                        hotDog && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundColor: colors/* default */.Z[hotDog.color]
                            },
                            className: "jsx-".concat(componentStyles.__hash) + " " + "hot-dog"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(componentStyles.__hash) + " " + "top-line",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "content-column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(componentStyles.__hash) + " " + "content-inner",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                dangerouslySetInnerHTML: {
                                                    __html: title
                                                },
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                dangerouslySetInnerHTML: {
                                                    __html: subtitle
                                                },
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-subtitle"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-signup-form",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                                    className: "align-left",
                                                    focusOnLoad: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-bullets",
                                                children: bullets.map(function(bullet, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-".concat(componentStyles.__hash) + " " + "bullet",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-".concat(componentStyles.__hash),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v/* default */.Z, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-".concat(componentStyles.__hash),
                                                                children: bullet
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("asset-column", {
                                        "with-shadow": shadow
                                    }) || ""),
                                    children: [
                                        hotDog && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                background: colors/* default */.Z[hotDog.color] || colors/* default */.Z[DEFAULT_HOTDOG_COLOR]
                                            },
                                            className: "jsx-".concat(componentStyles.__hash) + " " + "hot-dog"
                                        }),
                                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "".concat(image.widthPercentage, "%")
                                            },
                                            className: "jsx-".concat(componentStyles.__hash) + " " + "asset-inner",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({
                                                className: "main-image"
                                            }, image))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "down-arrow-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return HeaderWithTwoColumnsAndAssetComponent;
}(react.PureComponent);

HeaderWithTwoColumnsAndAssetComponent.defaultProps = {
    backgroundColor: "brand-purple",
    hotDog: {},
    asset: {},
    title: "",
    subtitle: "",
    signupForm: true,
    textColor: "",
    imageWidth: "50%",
    bullets: []
};

// EXTERNAL MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.js + 4 modules
var competitors_comparison_table_component = __webpack_require__(93030);
// EXTERNAL MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js + 1 modules
var signup_with_text_component = __webpack_require__(77385);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/templates/competitor-template/competitor-template.scss.js

var StyledCompetitorSignupForm = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eekrt5t0"
})("margin:32px 20px 100px 20px;display:flex;justify-content:center;");
var StyledFooterDisclaimer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eekrt5t1"
})("font-size:0.8125rem;width:100%;padding:16px 50px;");

;// CONCATENATED MODULE: ./components/templates/competitor-template/competitor-template.js




function competitor_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function competitor_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            competitor_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var CompetitorTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CompetitorTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CompetitorTemplate);
    function CompetitorTemplate() {
        (0,_class_call_check/* default */.Z)(this, CompetitorTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CompetitorTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var topSection = pageConfig.topSection, comparisonTable = pageConfig.comparisonTable, footerSignup = pageConfig.footerSignup, _footer = pageConfig.footer, footer = _footer === void 0 ? {} : _footer, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                var preventFooter = footer && footer.preventFooter;
                var hotDog = topSection.hotDog;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, _object_spread_props(competitor_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "competitor-top-bar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                                url: headerUrl,
                                loginTheme: loginTheme,
                                menuTheme: menuTheme,
                                showMenu: false,
                                stickyMode: stickyMode,
                                mobileLogoTheme: hotDog && hotDog.color == "brand-yellow" ? "black-theme" : "light-theme",
                                allowSocialButtons: socialButtons && socialButtons.show,
                                socialButtonsColor: socialButtons && socialButtons.color,
                                socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                                topBanner: topBanner,
                                maxWidth: "100%",
                                headerBackgroundColor: "white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWithTwoColumnsAndAssetComponent, competitor_template_object_spread({}, topSection)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(competitors_comparison_table_component/* default */.Z, competitor_template_object_spread({}, comparisonTable)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompetitorSignupForm, {
                                    className: "competitors-signup-form",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_text_component/* default */.Z, competitor_template_object_spread({}, footerSignup))
                                })
                            ]
                        }),
                        footer.disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterDisclaimer, {
                            className: "footer-disclaimer",
                            dangerouslySetInnerHTML: {
                                __html: footer.disclaimer
                            }
                        }),
                        !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(base_footer_component["default"], {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return CompetitorTemplate;
}(react.PureComponent);

CompetitorTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 68439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CompetitorTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_competitor_template_competitor_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58072);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49019);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var CompetitorTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CompetitorTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CompetitorTemplatePage);
    function CompetitorTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, CompetitorTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(CompetitorTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_competitor_template_competitor_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return CompetitorTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);



/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 53021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ slim_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var SlimFooter = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var SLIM_FOOTER = "slim";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderSlimFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {
            pageClusterConfig: pageClusterConfig,
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        var SlimFooterLinks = footerComponents.SlimFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: classnames_default()("footer-container", "slim-footer"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "categories-container",
                            children: SlimFooterLinks.map(function(column, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: column.type,
                                        links: column.links,
                                        hasMondayLogoTitle: index === 0
                                    })
                                });
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: SLIM_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderSlimFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var slim_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(SlimFooter)));
SlimFooter.defaultProps = default_props;


/***/ }),

/***/ 44574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ base_footer_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js + 1 modules
var slim_footer = __webpack_require__(53021);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/footer-consts.js
var footer_consts = __webpack_require__(99633);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/default-props.js
var default_props = __webpack_require__(96564);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.scss.js

var StyledBaseFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cyjyh50"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}






var BaseFooterComponent = function(props) {
    var _obj;
    var Footer = (_obj = {}, (0,_define_property/* default */.Z)(_obj, footer_consts/* LONG */.F, long_footer/* default */.Z), (0,_define_property/* default */.Z)(_obj, footer_consts/* SLIM */.z, slim_footer/* default */.Z), _obj)[props.footer_type] || slim_footer/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseFooterComponent, {
        className: "base-footer-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, _object_spread({}, props))
    });
};
BaseFooterComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var base_footer_component = (BaseFooterComponent);


/***/ }),

/***/ 96564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _footer_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99633);

/* harmony default export */ __webpack_exports__["Z"] = ({
    footer_type: _footer_consts__WEBPACK_IMPORTED_MODULE_0__/* .SLIM */ .z
});


/***/ }),

/***/ 99633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ LONG; },
/* harmony export */   "z": function() { return /* binding */ SLIM; }
/* harmony export */ });
var SLIM = "slim";
var LONG = "long";


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 5499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function(require,exports,module) {

return function ouibounce(el, custom_config) {
  "use strict";

  var config     = custom_config || {},
    aggressive   = config.aggressive || false,
    sensitivity  = setDefault(config.sensitivity, 20),
    timer        = setDefault(config.timer, 1000),
    delay        = setDefault(config.delay, 0),
    callback     = config.callback || function() {},
    cookieExpire = setDefaultCookieExpire(config.cookieExpire) || '',
    cookieDomain = config.cookieDomain ? ';domain=' + config.cookieDomain : '',
    cookieName   = config.cookieName ? config.cookieName : 'viewedOuibounceModal',
    sitewide     = config.sitewide === true ? ';path=/' : '',
    _delayTimer  = null,
    _html        = document.documentElement;

  function setDefault(_property, _default) {
    return typeof _property === 'undefined' ? _default : _property;
  }

  function setDefaultCookieExpire(days) {
    // transform days to milliseconds
    var ms = days*24*60*60*1000;

    var date = new Date();
    date.setTime(date.getTime() + ms);

    return "; expires=" + date.toUTCString();
  }

  setTimeout(attachOuiBounce, timer);
  function attachOuiBounce() {
    if (isDisabled()) { return; }

    _html.addEventListener('mouseleave', handleMouseleave);
    _html.addEventListener('mouseenter', handleMouseenter);
    _html.addEventListener('keydown', handleKeydown);
  }

  function handleMouseleave(e) {
    if (e.clientY > sensitivity) { return; }

    _delayTimer = setTimeout(fire, delay);
  }

  function handleMouseenter() {
    if (_delayTimer) {
      clearTimeout(_delayTimer);
      _delayTimer = null;
    }
  }

  var disableKeydown = false;
  function handleKeydown(e) {
    if (disableKeydown) { return; }
    else if(!e.metaKey || e.keyCode !== 76) { return; }

    disableKeydown = true;
    _delayTimer = setTimeout(fire, delay);
  }

  function checkCookieValue(cookieName, value) {
    return parseCookies()[cookieName] === value;
  }

  function parseCookies() {
    // cookies are separated by '; '
    var cookies = document.cookie.split('; ');

    var ret = {};
    for (var i = cookies.length - 1; i >= 0; i--) {
      var el = cookies[i].split('=');
      ret[el[0]] = el[1];
    }
    return ret;
  }

  function isDisabled() {
    return checkCookieValue(cookieName, 'true') && !aggressive;
  }

  // You can use ouibounce without passing an element
  // https://github.com/carlsednaoui/ouibounce/issues/30
  function fire() {
    if (isDisabled()) { return; }

    if (el) { el.style.display = 'block'; }

    callback();
    disable();
  }

  function disable(custom_options) {
    var options = custom_options || {};

    // you can pass a specific cookie expiration when using the OuiBounce API
    // ex: _ouiBounce.disable({ cookieExpire: 5 });
    if (typeof options.cookieExpire !== 'undefined') {
      cookieExpire = setDefaultCookieExpire(options.cookieExpire);
    }

    // you can pass use sitewide cookies too
    // ex: _ouiBounce.disable({ cookieExpire: 5, sitewide: true });
    if (options.sitewide === true) {
      sitewide = ';path=/';
    }

    // you can pass a domain string when the cookie should be read subdomain-wise
    // ex: _ouiBounce.disable({ cookieDomain: '.example.com' });
    if (typeof options.cookieDomain !== 'undefined') {
      cookieDomain = ';domain=' + options.cookieDomain;
    }

    if (typeof options.cookieName !== 'undefined') {
      cookieName = options.cookieName;
    }

    document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;

    // remove listeners
    _html.removeEventListener('mouseleave', handleMouseleave);
    _html.removeEventListener('mouseenter', handleMouseenter);
    _html.removeEventListener('keydown', handleKeydown);
  }

  return {
    fire: fire,
    disable: disable,
    isDisabled: isDisabled
  };
}

/*exported ouibounce */
;

}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5961,4102,2448,4218,6250,4800,9861,627,6720,7445,2727,8124,1882,9019,9774,2888,179], function() { return __webpack_exec__(22044); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);